import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PrayerTimes from "../user-settings/prayer-times";
import BackButton from "../../../components/buttons/BackButton";
import MethodCards from "./method-cards";

const PrayerTimeIqamah = () => {
  const { t } = useTranslation();
  const [inUse, setInUse] = useState("");

  return (
    <>
      <section className="bg-gradient-to-b from-slate-50 to-gray-50">
        <div className="max-w-4xl p-6 space-y-6">
          <h1 className="text-2xl text-start font-semibold text-slate-800 flex items-center gap-2">
            <BackButton /> {t("iqamahCalculationTitle")}
          </h1>
          <MethodCards
            base="/user-dashboard/prayer-times/iqamah"
            inUse={inUse}
            calculateTitle="Delays after the athan or fixed times"
            calculateText="For example 10 minutes after the athan, or always at 13:30."
            importText="Upload your own iqamah timetable (CSV or Excel)."
          />
        </div>
      </section>

      <PrayerTimes mode="iqamah" onLoaded={(data) => setInUse(data.isCustom ? "custom" : "method")} />
    </>
  );
};

export default PrayerTimeIqamah;
